module.exports = __webpack_public_path__ + "static/media/bianco_trasparente.8dce40e6.png";